module.exports = __webpack_public_path__ + "static/img/risk-icon6.e6627d25.png";